import { useNavigate } from "react-router-dom"
import { IoWarningOutline } from "react-icons/io5";

const LoginAndPrepareOfferDetails = ({ offerNo, offerSiteId, isOfferRequest }) => {
    const navigate = useNavigate()

    return (
        <div className="container main-container-holder">
            <div className="row">
                <div className='d-flex flex-column align-items-center justify-content-center' style={{ fontSize: '25px' }}>
                    <IoWarningOutline size={150} className='warning-text-color ' />
                    <span className='mt-5'>Aby przejrzeć szczegóły oferty, musisz być zalogowany na kontrahenta, </span>
                    <span>na którego została ona stworzona.</span>
                    <div className="d-flex mt-5">
                        <button className='btn-app-primary me-5' onClick={() => navigate('/login', { state: { redirectParams: { offerNo, offerSiteId, isOfferRequest } }, replace: true })}>Zaloguj się</button>
                        <button className='btn-app-secondary' onClick={() => navigate('/', { replace: true })}>Powrót na stronę główną</button>
                    </div>
                </div>
            </div>
        </div>
    )
}

export default LoginAndPrepareOfferDetails